export default __webpack_public_path__ + "static/media/322.0671f656.jpg";